import React from 'react';
import PropTypes from 'prop-types';
import {BlocksControls, InlineImage} from 'react-tinacms-inline';
import {box, simpleBlockFields} from '../../constants/fields/fields';
import {imageTemplate} from '../../constants/templates/image';
import {ImageStyled} from '../Common/ImageStyled';
import {useBlockProps} from '../../hooks/useBlockProps';
import {Content} from '../Common/Content';
import {imageSimpleField} from '../../constants/fields/image.fields';
import {getMediaURL} from '../../utils/renderMedia';

function ImageComponent({index, data}) {
  const {blockProps} = useBlockProps(data);
  return (
    <div>
      <BlocksControls index={index} focusRing={{offset: 0}}>
        <Content {...blockProps} className={'dlf-no-margin-horizontal'}>
          <ImageStyled {...blockProps.media} viewport={blockProps.viewport}>
            <InlineImage
              name="media.src"
              className={`shadow-${blockProps.shadow}`}
              parse={(media) => media.src}
              uploadDir={() => '/'}
              previewSrc={(src) => getMediaURL(src)}
              focusRing={false}
              alt={data?.media?.alt}
            >
              {(({src, alt}) => <img src={getMediaURL(src)} alt={alt}/>)}
            </InlineImage>
          </ImageStyled>
        </Content>
      </BlocksControls>
    </div>
  );
}

const template = {
  label: 'Image',
  defaultItem: imageTemplate,
  fields: [
    ...imageSimpleField,
    // shadow,
    box
  ]
};

export const Image = {
  Component: ImageComponent,
  template
};
export const ImageForColumn = {
  Component: ImageComponent,
  template: {
    ...template,
    fields: [
      ...imageSimpleField,
      // shadow,
      ...simpleBlockFields
    ]
  }
};

ImageComponent.propTypes = {
  data: PropTypes.object,
  index: PropTypes.number
};
